<div>
	<mat-spinner [diameter]="diameter"></mat-spinner>
	<span *ngIf="message">{{ message | translate }}</span>
</div>
